/* Fahhar — Mağaza stok durumu (ürün sayfası)
   Veri: snippets/fk-magaza-stok.liquid içindeki JSON (ayar + ürün metafield'ı). */
(function () {
  'use strict';
  if (window.customElements.get('fk-magaza-stok')) return;

  var BAYAT_MS = 26 * 60 * 60 * 1000;      // veri 26 saatten eskiyse bileşen gizlenir
  var ORNEK = [5, 2, 0, 4, 1, 6, 0, 3];      // örnek veri dağılımı (yalnız önizleme)
  var BEDEN_RE = /beden|size|ya[sş]|numara/i;

  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  // Örnek veri yalnız yayında olmayan temada (önizleme) gösterilir; tema yayına alınınca kendiliğinden kapanır
  function canliTema() {
    var t = window.Shopify && window.Shopify.theme;
    return !!(t && t.role === 'main');
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  class FkMagazaStok extends HTMLElement {
    connectedCallback() {
      if (this._hazir) return;
      this._hazir = true;
      var kaynak = this.querySelector('script[data-fk-ms-json]');
      if (!kaynak) return;
      try { this.d = JSON.parse(kaynak.textContent); } catch (e) { return; }

      var ayar = this.d.ayar || {};
      this.esik = Number(ayar.esik) > 0 ? Number(ayar.esik) : 3;
      this.magazalar = Array.isArray(ayar.magazalar) ? ayar.magazalar : [];
      this.varyantlar = Array.isArray(this.d.varyantlar) ? this.d.varyantlar : [];
      if (!this.magazalar.length || !this.varyantlar.length) return;

      var stok = this.d.stok;
      this.ornek = false;
      if (stok && stok.s && typeof stok.s === 'object') {
        var t = Date.parse(stok.t || '');
        if (!isNaN(t) && Date.now() - t > BAYAT_MS) return;
        this.veri = stok.s;
      } else if (ayar.ornek === true && !canliTema()) {
        this.ornek = true;
      } else {
        return;
      }

      this.vmap = {};
      for (var i = 0; i < this.varyantlar.length; i++) this.vmap[String(this.varyantlar[i].id)] = this.varyantlar[i];
      this.secenekler = Array.isArray(this.d.secenekler) ? this.d.secenekler : [];
      this.bedenIdx = this.secenekler.findIndex(function (n) { return BEDEN_RE.test(n); });
      if (this.bedenIdx < 0) this.bedenIdx = this.secenekler.length - 1;

      this.trigger = this.querySelector('.fk-ms__trigger');
      this.ozet = this.querySelector('[data-fk-ms-summary]');
      this.dialog = this.querySelector('dialog');
      this.liste = this.querySelector('[data-fk-ms-list]');
      this.bedenler = this.querySelector('[data-fk-ms-sizes]');
      if (this.ornek) this.querySelector('[data-fk-ms-demo]').hidden = false;

      this.form = this.formBul();
      this.baglan();
      this.hidden = false;
      this.esitle(this.seciliId(), true);
    }

    formBul() {
      var alan = this.closest('.shopify-section') || document;
      var formlar = alan.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < formlar.length; i++) {
        var inp = formlar[i].querySelector('[name="id"]');
        if (inp && this.vmap[String(inp.value)]) return formlar[i];
      }
      return formlar[0] || null;
    }

    seciliId() {
      var inp = this.form && this.form.querySelector('[name="id"]');
      if (inp && this.vmap[String(inp.value)]) return String(inp.value);
      var u = new URLSearchParams(location.search).get('variant');
      if (u && this.vmap[u]) return u;
      return String(this.d.secili || this.varyantlar[0].id);
    }

    baglan() {
      var self = this;
      var tekrar = function () { setTimeout(function () { self.esitle(self.seciliId()); }, 60); };
      if (this.form) {
        this.form.addEventListener('variant:change', function (e) {
          var v = e.detail && (e.detail.variant || e.detail.selectedVariant);
          if (v && v.id && self.vmap[String(v.id)]) self.esitle(String(v.id)); else tekrar();
        });
      }
      var alan = this.closest('.shopify-section') || document;
      alan.addEventListener('change', tekrar, true);
      document.addEventListener('variant:change', tekrar);          // Prestige ve benzerleri
      document.addEventListener('variant:update', tekrar);          // Horizon
      document.addEventListener('product:variant-change', function (e) { // Stiletto (fahhar.com)
        var v = e.detail && e.detail.variant;
        if (v && v.id && self.vmap[String(v.id)]) self.esitle(String(v.id)); else tekrar();
      });
      window.addEventListener('popstate', tekrar);

      this.trigger.addEventListener('click', function () { self.ac(); });
      this.querySelector('[data-fk-ms-close]').addEventListener('click', function () { self.kapat(); });
      this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.kapat(); });
      this.dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('fk-ms-kilit');
        self.trigger.focus({ preventScroll: true });
      });
    }

    adet(vid, kod) {
      if (this.ornek) {
        var sira = 0;
        for (var i = 0; i < this.magazalar.length; i++) if (this.magazalar[i].kod === kod) sira = i;
        return ORNEK[(hash(String(vid)) + sira * 3) % ORNEK.length];
      }
      var satir = this.veri[vid];
      var q = satir ? Number(satir[kod]) : 0;
      return q > 0 ? q : 0;
    }
    durum(q) { return q <= 0 ? 'yok' : (q <= this.esik ? 'kritik' : 'var'); }

    damga() { return el('span', 'fk-ms__stamp', 'Kritik stok'); }

    esitle(vid, ilk) {
      if (!vid || (!ilk && vid === this.cur)) return;
      this.cur = vid;
      this.ozetYaz(vid);
      if (this.dialog.open) { this.gorunen = vid; this.panelYaz(); }
    }

    ozetYaz(vid) {
      var varSay = 0, kritikSay = 0;
      for (var i = 0; i < this.magazalar.length; i++) {
        var d = this.durum(this.adet(vid, this.magazalar[i].kod));
        if (d === 'var') varSay++; else if (d === 'kritik') kritikSay++;
      }
      var n = varSay + kritikSay;
      this.ozet.textContent = '';
      this.ozet.appendChild(el('span', null, n ? n + ' mağazada stokta' : 'Mağazalarda stokta yok'));
      if (kritikSay) this.ozet.appendChild(this.damga());
      if (this.ornek) this.ozet.appendChild(el('span', 'fk-ms__demo', 'Örnek veri'));
    }

    ac() {
      this.gorunen = this.seciliId();
      this.panelYaz();
      document.documentElement.classList.add('fk-ms-kilit');
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
    }
    kapat() {
      if (typeof this.dialog.close === 'function') this.dialog.close();
      else this.dialog.removeAttribute('open');
      document.documentElement.classList.remove('fk-ms-kilit');
    }

    panelYaz() {
      var self = this;
      var v = this.vmap[this.gorunen] || this.varyantlar[0];

      // Beden seçenekleri: aynı renk/diğer seçeneklerdeki varyantlar
      this.bedenler.textContent = '';
      var bi = this.bedenIdx;
      var kardes = this.varyantlar.filter(function (x) {
        return (x.o || []).every(function (val, i) { return i === bi || val === v.o[i]; });
      });
      if (bi >= 0 && kardes.length > 1) {
        this.bedenler.appendChild(el('p', 'fk-ms__sizes-label', (this.secenekler[bi] || 'Beden') + ': ' + (v.o[bi] || '')));
        var grup = el('div', 'fk-ms__chips');
        grup.setAttribute('role', 'group');
        grup.setAttribute('aria-label', this.secenekler[bi] || 'Beden');
        kardes.forEach(function (x) {
          var b = el('button', 'fk-ms__chip', x.o[bi]);
          b.type = 'button';
          b.setAttribute('aria-pressed', String(String(x.id) === String(v.id)));
          b.addEventListener('click', function () { self.gorunen = String(x.id); self.panelYaz(); });
          grup.appendChild(b);
        });
        this.bedenler.appendChild(grup);
      } else if (v.o && v.o.length) {
        this.bedenler.appendChild(el('p', 'fk-ms__sizes-label', this.secenekler.map(function (n, i) { return n + ': ' + v.o[i]; }).join(' · ')));
      }

      // Mağazalar: önce stokta, sonra kritik, en son stokta olmayanlar
      var sira = { 'var': 0, 'kritik': 1, 'yok': 2 };
      var satirlar = this.magazalar.map(function (m, i) {
        var q = self.adet(String(v.id), m.kod);
        return { m: m, q: q, d: self.durum(q), i: i };
      }).sort(function (a, b) { return (sira[a.d] - sira[b.d]) || (a.i - b.i); });

      this.liste.textContent = '';
      satirlar.forEach(function (s) {
        var li = el('li', 'fk-ms__row fk-ms__row--' + s.d);
        var sol = el('div', 'fk-ms__row-main');
        if (s.m.sehir) sol.appendChild(el('p', 'fk-ms__city', s.m.sehir));
        sol.appendChild(el('p', 'fk-ms__name', s.m.ad));
        if (s.m.adres) sol.appendChild(el('p', 'fk-ms__addr', s.m.adres));
        var meta = el('p', 'fk-ms__meta');
        if (s.m.saat) meta.appendChild(el('span', null, s.m.saat));
        if (s.m.harita) {
          var a = el('a', 'fk-ms__map', 'Yol tarifi');
          a.href = s.m.harita; a.target = '_blank'; a.rel = 'noopener';
          meta.appendChild(a);
        }
        sol.appendChild(meta);

        var sag = el('div', 'fk-ms__status');
        var etiket = s.d === 'var' ? 'Stokta' : (s.d === 'kritik' ? 'Son ' + s.q + ' ürün' : 'Stokta yok');
        var st = el('span', 'fk-ms__state');
        st.appendChild(el('i', 'fk-ms__dot'));
        st.appendChild(document.createTextNode(etiket));
        sag.appendChild(st);
        if (s.d === 'kritik') sag.appendChild(self.damga());

        li.appendChild(sol);
        li.appendChild(sag);
        self.liste.appendChild(li);
      });
    }
  }

  window.customElements.define('fk-magaza-stok', FkMagazaStok);
})();
